import React, { useState, useEffect, useMemo, useRef } from 'react';
import { collection, getDocs, query, where, doc, getDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';
import { ReactComponent as EventosIcon } from '../../assets/icons/EventosIcon.svg';
import { ReactComponent as StaffIcon } from '../../assets/icons/StaffIcon.svg';
import { ReactComponent as ClientesIcon } from '../../assets/icons/ClientesIcon.svg';
import CalendarModal from './CalendarModal';
import { getAuth } from 'firebase/auth';
import { useNavigate, useParams } from 'react-router-dom';
import { Combobox } from '@headlessui/react';
const DegustacionesForm = () => {
const { id } = useParams();
const isEditing = !!id;
const [isCalendarModalVisible, setIsCalendarModalVisible] = useState(false);
const [isLoading, setIsLoading] = useState(false);
const [saveState, setSaveState] = useState('idle'); // 'idle' | 'saved'
const [progress, setProgress] = useState(0);
const navigate = useNavigate();
const [formData, setFormData] = useState({
// CAMBIO 1: fechas ahora es null para una sola fecha
fechas: null, // Guarda la única fecha seleccionada (Date object) o null
hora: '',
coleccion: [],
staff: [{ nombre: '', rol: 'Sommelier' }],
invitados: Array(8).fill(null),
});
const [vinos, setVinos] = useState([]);
const [contactos, setContactos] = useState([]);
const [selectedVino, setSelectedVino] = useState('');
const [vinoQuery, setVinoQuery] = useState('');
const [openClientListbox, setOpenClientListbox] = useState(null);
const [searchTerm, setSearchTerm] = useState('');
const dropdownRef = useRef(null);
const searchInputRef = useRef(null);
const filterButtonsRef = useRef([]);
const [contactTypeFilter, setContactTypeFilter] = useState('');
const [clientes, setClientes] = useState([]);
const [proveedores, setProveedores] = useState([]);
const [otros, setOtros] = useState([]);
const [usuarios, setUsuarios] = useState([]);
const [hoveredCircleIndex, setHoveredCircleIndex] = useState(null);
const filteredContactsByType = useMemo(() => {
let contactsToFilter = [];
switch (contactTypeFilter) {
case 'clientes':
contactsToFilter = clientes;
break;
case 'proveedores':
contactsToFilter = proveedores;
break;
case 'otros':
contactsToFilter = otros;
break;
case 'usuarios':
contactsToFilter = usuarios;
break;
case 'todos':
default:
contactsToFilter = contactos;
break;
}
const selectedContactIds = formData.invitados.filter((invitado) => invitado).map((invitado) => invitado.id);
const filtered = contactsToFilter.filter((contacto) => {
const isSelected = selectedContactIds.includes(contacto.id);
if (isSelected) return false;
const nombreCompleto = contacto.nombre && contacto.apellido
? `${contacto.nombre} ${contacto.apellido}`
: contacto.nombre
? contacto.nombre
: contacto.razonSocial
? contacto.razonSocial
: '';
return nombreCompleto.toLowerCase().includes(searchTerm.toLowerCase());
});
filtered.sort((a, b) => {
const nameA = a.nombre && a.apellido ? `${a.nombre} ${a.apellido}` : a.nombre ? a.nombre : a.razonSocial || '';
const nameB = b.nombre && b.apellido ? `${b.nombre} ${b.apellido}` : b.nombre ? b.nombre : b.razonSocial || '';
return nameA.localeCompare(nameB);
});
return filtered;
}, [contactTypeFilter, searchTerm, clientes, proveedores, otros, usuarios, contactos, formData.invitados]);
useEffect(() => {
const fetchAllData = async () => {
setIsLoading(true);
try {
const [vinosSnapshot, clientesSnapshot, proveedoresSnapshot, otrosSnapshot, usuariosSnapshot] = await Promise.all([
getDocs(query(collection(db, 'stock'), where('cantidadUnidades', '>', 0))),
getDocs(query(collection(db, 'clientes'))),
getDocs(query(collection(db, 'proveedores'))),
getDocs(query(collection(db, 'otros'))),
getDocs(query(collection(db, 'usuarios')))
]);
const vinosList = vinosSnapshot.docs
.map(doc => ({ id: doc.id, ...doc.data() }))
.filter(vino => vino.vino_id && !vino.id.startsWith('DEMO-')); // demo de fincalosastros
vinosList.sort((a, b) => a.id.localeCompare(b.id, 'es', { sensitivity: 'base' }));
setVinos(vinosList);
// Cuentas de staff usadas para probar el sitio público como si fueran
// clientes (Martín Gallo, Tomás Sitta) — ya aparecen abajo como 'usuarios',
// no deben duplicarse acá como 'clientes'. Sacar cuando ya no hagan falta.
const UIDS_CUENTAS_DE_PRUEBA = ['31464078', '42876938', '34853820', '36398917'];
const clientesList = clientesSnapshot.docs
.filter(doc => !UIDS_CUENTAS_DE_PRUEBA.includes(doc.id))
.map(doc => ({ id: doc.id, ...doc.data(), tipo: 'clientes' }));
const proveedoresList = proveedoresSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data(), tipo: 'proveedores' }));
const otrosList = otrosSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data(), tipo: 'otros' }));
const usuariosList = usuariosSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data(), tipo: 'usuarios' }));
setClientes(clientesList);
setProveedores(proveedoresList);
setOtros(otrosList);
setUsuarios(usuariosList);
const allContacts = [...clientesList, ...proveedoresList, ...otrosList, ...usuariosList];
allContacts.sort((a, b) => {
const nameA = a.nombre && a.apellido ? `${a.nombre} ${a.apellido}` : a.nombre ? a.nombre : a.razonSocial || '';
const nameB = b.nombre && b.apellido ? `${b.nombre} ${b.apellido}` : b.nombre ? b.nombre : b.razonSocial || '';
return nameA.localeCompare(nameB);
});
setContactos(allContacts);
if (isEditing && id) {
const docRef = doc(db, 'degustaciones', id);
const docSnap = await getDoc(docRef);
if (docSnap.exists()) {
const eventData = docSnap.data();
const vinoIdsFromNames = eventData.coleccion
.map(nombreVino => {
const vinoEncontrado = vinosList.find(v => v.id === nombreVino);
return vinoEncontrado ? vinoEncontrado.vino_id : null;
})
.filter(vinoId => vinoId);

// Lógica para establecer la única fecha y hora
let fechaUnica = null;
if (eventData.fechas && eventData.fechas.length > 0) {
// Tomamos la primera fecha como la única, y la convertimos a Date
const rawDate = eventData.fechas[0];
fechaUnica = rawDate.seconds ? new Date(rawDate.seconds * 1000) : new Date(rawDate);
}

setFormData({
// CAMBIO 2: Asignar la única fecha
fechas: fechaUnica,
hora: eventData.hora || '',
coleccion: vinoIdsFromNames,
staff: eventData.staff && eventData.staff.length > 0 ? [{ nombre: eventData.staff[0].nombre, rol: 'Sommelier' }] : [{ nombre: '', rol: 'Sommelier' }],
invitados: eventData.invitados ? [...eventData.invitados, ...Array(8 - eventData.invitados.length).fill(null)].slice(0, 8) : Array(8).fill(null),
});
} else {
console.log('No se encontró el documento.');
navigate('/eventos');
}
}
} catch (error) {
console.error('Error al cargar datos:', error);
} finally {
setIsLoading(false);
}
};
fetchAllData();
}, [id, isEditing, navigate]);
const handleMouseEnter = (index) => {
setHoveredCircleIndex(index);
};
const handleStaffChange = (e, index) => {
const newStaff = [...formData.staff];
newStaff[index].nombre = e.target.value;
setFormData({ ...formData, staff: newStaff });
};
const handleMouseLeave = () => {
setHoveredCircleIndex(null);
};
const handleAddVino = (vinoId) => {
if (vinoId && !formData.coleccion.includes(vinoId)) {
setFormData({
...formData,
coleccion: [...formData.coleccion, vinoId],
});
setSelectedVino('');
}
};
const handleSelectClient = (cliente, index) => {
const newInvitados = [...formData.invitados];
newInvitados[index] = cliente;
setFormData({ ...formData, invitados: newInvitados });
setOpenClientListbox(null);
};
const handleRemoveClient = (index) => {
const newInvitados = [...formData.invitados];
newInvitados[index] = null;
setFormData({ ...formData, invitados: newInvitados });
};
const filteredContacts = useMemo(() => {
const selectedContactIds = formData.invitados.filter((invitado) => invitado).map((invitado) => invitado.id);
const filtered = contactos.filter((contacto) => {
const isSelected = selectedContactIds.includes(contacto.id);
if (isSelected) {
return false;
}
const nombreCompleto = contacto.nombre && contacto.apellido
? `${contacto.nombre} ${contacto.apellido}`
: contacto.nombre
? contacto.nombre
: contacto.razonSocial
? contacto.razonSocial
: '';
return nombreCompleto.toLowerCase().includes(searchTerm.toLowerCase());
});
filtered.sort((a, b) => {
const nameA = a.nombre && a.apellido ? `${a.nombre} ${a.apellido}` : a.nombre ? a.nombre : a.razonSocial || '';
const nameB = b.nombre && b.apellido ? `${b.nombre} ${b.apellido}` : b.nombre ? b.nombre : b.razonSocial || '';
return nameA.localeCompare(nameB);
});
return filtered;
}, [contactos, searchTerm, formData.invitados]);
const handleRemoveArrayItem = (index, arrayName) => {
if (arrayName === 'coleccion') {
const newArray = [...formData[arrayName]];
newArray.splice(index, 1);
setFormData({ ...formData, [arrayName]: newArray });
}
// CAMBIO 3: Lógica para remover fecha si se usara un botón, pero la quitamos del array
/*
if (arrayName === 'fechas') {
const newArray = [...formData[arrayName]];
newArray.splice(index, 1);
setFormData({ ...formData, [arrayName]: newArray });
}
*/
};
const handleOpenCalendarModal = (index = null) => {
setIsCalendarModalVisible(true);
};
const handleCloseCalendarModal = () => {
setIsCalendarModalVisible(false);
};

// CAMBIO 4: Se espera un array de una única fecha (selectedDates[0])
const handleDatesSelected = ({ selectedDates, selectedTime }) => {
// Solo tomamos la primera fecha y la guardamos directamente
const singleDate = selectedDates && selectedDates.length > 0 ? selectedDates[0] : null;

setFormData({
...formData,
fechas: singleDate, // Guardamos la fecha única
hora: selectedTime,
});
handleCloseCalendarModal();
};
const availableVinos = vinos.filter(
(vino) => !formData.coleccion.includes(vino.vino_id)
);
const filteredVinos =
vinoQuery === ''
? availableVinos
: availableVinos.filter((vino) => {
const vinoNombreCompleto = `${vino.bodega} ${vino.cepa} ${vino.linea} ${vino.vino_id}`;
// Corregido: La comparación debe ser con vinoQuery
return vinoNombreCompleto.toLowerCase().includes(vinoQuery.toLowerCase());
});
const handleSubmit = async (e) => {
e.preventDefault();
setIsLoading(true);
setSaveState('idle');
setProgress(0);
const invitadosSeleccionados = formData.invitados.filter((i) => i !== null);
const user = getAuth().currentUser;
if (!user) {
console.error('Usuario no autenticado.');
setIsLoading(false);
return;
}
let fakeProgress = 0;
const interval = setInterval(() => {
fakeProgress += 10;
setProgress(fakeProgress);
if (fakeProgress >= 90) clearInterval(interval);
}, 200);
try {
const idToken = await user.getIdToken();
const formDataToSend = new FormData();
formDataToSend.append('hora', formData.hora);
// CAMBIO 5: Enviamos la fecha única como un array de un elemento si existe, o un array vacío
formDataToSend.append('fechas', JSON.stringify(formData.fechas ? [formData.fechas] : []));
formDataToSend.append('coleccion', JSON.stringify(formData.coleccion));
formDataToSend.append('staff', JSON.stringify(formData.staff));
formDataToSend.append('invitados', JSON.stringify(invitadosSeleccionados));
const endpoint = isEditing ? `https://backend-288175208699.europe-west1.run.app/actualizar-degustacion/${id}` : 'https://backend-288175208699.europe-west1.run.app/nueva-degustacion';
const method = isEditing ? 'PUT' : 'POST';
const res = await fetch(endpoint, {
method: method,
headers: {
Authorization: `Bearer ${idToken}`,
},
body: formDataToSend,
});
const data = await res.json();
if (!res.ok) throw new Error(data.error || 'Error en la operación');
clearInterval(interval);
setProgress(100);
setSaveState('saved');
setTimeout(() => {
navigate('/eventos');
}, 800);
} catch (error) {
alert(error.message);
setIsLoading(false);
setProgress(0);
}
};
useEffect(() => {
const handleOutsideClick = (event) => {
if (openClientListbox !== null) {
const dropdownElement = dropdownRef.current;
const searchInputElement = searchInputRef.current;
const isClickInsideFilterButtons = filterButtonsRef.current.some(
(button) => button && button.contains(event.target)
);
if (
dropdownElement &&
!dropdownElement.contains(event.target) &&
!(searchInputElement && searchInputElement.contains(event.target)) &&
!isClickInsideFilterButtons
) {
setOpenClientListbox(null);
}
}
};
document.addEventListener('mousedown', handleOutsideClick);
return () => {
document.removeEventListener('mousedown', handleOutsideClick);
};
}, [openClientListbox]);

// Función para formatear la fecha y hora seleccionada
const formatSelectedDateTime = (date, time) => {
if (!date || !time) return 'Seleccionar fecha y hora';

// Formatear la fecha
const formattedDate = date.toLocaleDateString('es-ES', {
weekday: 'short',
day: 'numeric',
month: 'short',
year: 'numeric',
});
// Capitalizar el día de la semana
const capitalizedDate = formattedDate.substring(0, 1).toUpperCase() + formattedDate.substring(1);

// Combinar fecha y hora
return `${capitalizedDate} - ${time}`;
};


return (
<div style={{ padding: '0 16px', overflow: 'hidden', height: '100%' }}>
<header className="trazabilidad-header">
<div className="header-content">
<h1>Eventos</h1>
</div>
</header>
<div className="container" style={{ margin: '0 10px' }}>
<div className="formtitle-container">
<div className="formicon-container">
<EventosIcon className="formicon" style={{ height: '20px', margin: 'auto' }} />
</div>
<h1 className="formtitle"> {isEditing ? 'Actualizar datos de la degustación' : 'Crear una nueva degustación'}</h1>
</div>
<hr className="divider" />
<form className="form" onSubmit={handleSubmit} style={{ maxHeight: '75vh' }}>
{}
<div 
className="degustaciones-form-top-row" 
style={{ 
display: 'grid', 
gridTemplateColumns: 'repeat(3, 1fr)', 
gap: '50px', 
}}
>
{}
<div className="degustaciones-fecha-col">
{/* CAMBIO 6: Mostramos el valor formateado en el input principal */}
<div
className="eventos-form-input"
onClick={() => handleOpenCalendarModal()}
style={{ borderRadius: '7px', width: '100%', marginBottom: '10px', cursor: 'pointer' }}
>
<span>
{formatSelectedDateTime(formData.fechas, formData.hora)}
</span>
</div>

</div>
{}
<div className="degustaciones-vinos-col">
{}
<div className="eventos-form-input-group" style={{ width: '100%' }}>
<div className="input-group">
<Combobox
value={selectedVino}
onChange={(value) => {
handleAddVino(value);
setVinoQuery('');
}}
>
{({ open }) => (
<>
<div style={{ position: 'relative', width: '100%' }}>
<Combobox.Button
as="div"
className={`custom-listbox-button ${open ? 'open' : ''} ${selectedVino ? 'selected' : 'placeholder'}`}
style={{ width: '100%', borderRadius: '5px' }}
>
<Combobox.Input
className="custom-combobox-input"
onChange={(event) => setVinoQuery(event.target.value)}
displayValue={(vinoId) => {
const vino = vinos.find((v) => v.vino_id === vinoId);
return vino ? `${vino.bodega} ${vino.cepa} ${vino.linea} ${vino.vino_id}` : '';
}}
placeholder="Selecciona un vino"
style={{
flexGrow: 1,
padding: '0',
border: 'none',
outline: 'none',
backgroundColor: 'transparent',
}}
/><span className="custom-arrow-container" style={{ marginRight: '5px' }}>
<span className="custom-arrow"></span>
</span>
</Combobox.Button>
<Combobox.Options className="custom-listbox-options" style={{ width: '100%' }}>
{filteredVinos.length === 0 && vinoQuery !== '' ? (
<div className="custom-listbox-option">No se encontraron vinos.</div>
) : (
filteredVinos.map((vino) => (
<Combobox.Option
key={vino.vino_id}
value={vino.vino_id}
className={({ active }) => `custom-listbox-option ${active ? 'active' : ''}`}
>
{`${vino.vino_id}`}
</Combobox.Option>
))
)}
</Combobox.Options>
</div>
</>
)}
</Combobox>
</div>
{formData.coleccion.length > 0 && (
<div style={{ display: 'flex', flexDirection: 'row', gap: '5px', flexWrap: 'wrap', marginTop: '10px' }}>
{formData.coleccion.map((vinoId, index) => {
const vino = vinos.find((v) => v.vino_id === vinoId);
if (!vino) return null;
return (
<div key={index} className="eventos-form-input-group number" style={{ minWidth: '80px', borderRadius: '50px', maxWidth: '100%', padding: '5px 10px ' }}>
<span style={{ cursor: 'default', maxWidth: '250px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', verticalAlign: 'middle' }}>{vino.id}</span>
<div className="add-fecha" style={{ right: '5px', background: 'none', fontSize: '17px' }} onClick={() => handleRemoveArrayItem(index, 'coleccion')}>
&times;
</div>
</div>
);
})}
</div>)}
</div>
</div>
{}
<div className="degustaciones-staff-col">
<div className="eventos-form-label-container">
<StaffIcon className="eventos-form-icon" />
<label className="eventos-form-label">Staff</label>
</div>
<div className="eventos-form-input-group eventos-form-array">
{formData.staff.map((item, index) => {
return (
<div key={index} className="eventos-form-array-item" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
<input
className="eventos-form-input"
type="text"
value={item.nombre}
onChange={(e) => handleStaffChange(e, index)}
placeholder={`Nombre del ${item.rol.toLowerCase()}`}
style={{ flex: 1 }}
/>
</div>
);
})}
</div>
</div>
</div>
<div className="eventos-form-secondary-column" style={{ width: '40%', padding: '0 10px', margin: '0 auto 0' }}>
<div className="eventos-form-label-container" style={{ margin: '0', padding: '0', border: 'none' }}>
<ClientesIcon className="eventos-form-icon" style={{ fill: '#2c2c2c' }} />
<label className="eventos-form-label" style={{ margin: '0', padding: '0' }}>Mesa de invitados (8 puestos)</label>
</div>
<div 
className="eventos-form-invitados-horizontal" 
style={{ 
display: 'flex', 
flexDirection: 'column', 
alignItems: 'center', 
gap: '10px',
}}
>
{}
<div className="eventos-form-invitados-row" style={{ display: 'flex', gap: '30px',width:'100%', justifyContent:'space-between' }}>
{formData.invitados.slice(0, 4).map((invitado, index) => (
<div key={index} style={{ position: 'relative', margin:'0 auto' }}>
<div
className={`eventos-form-invitado-circle ${invitado ? 'filled' : 'empty'} ${openClientListbox === index ? 'active' : ''}`}
onClick={() => {
setOpenClientListbox(openClientListbox === index ? null : index);
setSearchTerm('');
}}
onMouseEnter={() => handleMouseEnter(index)}
onMouseLeave={handleMouseLeave}
>
{invitado ? (
<>
<span>
{invitado.nombre && invitado.apellido
? `${invitado.nombre.charAt(0).toUpperCase()}${invitado.apellido.charAt(0).toUpperCase()}`
: invitado.nombre
? invitado.nombre.charAt(0).toUpperCase()
: invitado.razonSocial
? invitado.razonSocial.charAt(0).toUpperCase()
: ''}
</span>
<div
className="eventos-form-remove-client"
onClick={(e) => {
e.stopPropagation();
handleRemoveClient(index);
}}
>
&times;
</div>
</>
) : (
<span>+</span>
)}
</div>
{hoveredCircleIndex === index && invitado && (
<div className="custom-tooltip">
{invitado.nombre && invitado.apellido
? `${invitado.nombre} ${invitado.apellido}`
: invitado.nombre
? invitado.nombre
: invitado.razonSocial}
</div>
)}
<div
className={`invitados-listbox-container ${openClientListbox !== index ? 'hidden' : ''} `} 
ref={openClientListbox === index ? dropdownRef : null}
style={{left: '50%',}} 
>
<input
type="text"
placeholder="Buscar cliente..."
value={searchTerm}
onChange={(e) => setSearchTerm(e.target.value)}
className="invitados-listbox-search-input"
ref={openClientListbox === index ? searchInputRef : null}
/>
<div className="filter-buttons-container" style={{ display: 'flex', width: '90%', margin: '5px auto 10px', gap: '5px', flexWrap: 'wrap' }}>
<button
type="button"
className={`filter-button ${contactTypeFilter === 'clientes' ? 'active' : ''}`}
onClick={() => setContactTypeFilter(contactTypeFilter === 'clientes' ? 'todos' : 'clientes')}
ref={(el) => (filterButtonsRef.current[0] = el)}
style={{ maxWidth: 'fit-content', padding: '1px 5px' }}
>
Clientes
</button>
<button
type="button"
className={`filter-button ${contactTypeFilter === 'usuarios' ? 'active' : ''}`}
onClick={() => setContactTypeFilter(contactTypeFilter === 'usuarios' ? '' : 'usuarios')}
ref={(el) => (filterButtonsRef.current[3] = el)}
style={{ maxWidth: 'fit-content', padding: '1px 5px' }}
>Empleados
</button>
<button
type="button"
className={`filter-button ${contactTypeFilter === 'proveedores' ? 'active' : ''}`}
onClick={() => setContactTypeFilter(contactTypeFilter === 'proveedores' ? 'todos' : 'proveedores')}
ref={(el) => (filterButtonsRef.current[1] = el)}
style={{ maxWidth: 'fit-content', padding: '1px 5px' }}
>
Proveedores
</button>
<button
type="button"
className={`filter-button ${contactTypeFilter === 'otros' ? 'active' : ''}`}
onClick={() => setContactTypeFilter(contactTypeFilter === 'otros' ? 'todos' : 'otros')}
ref={(el) => (filterButtonsRef.current[2] = el)}
style={{ maxWidth: 'fit-content', padding: '1px 5px' }}
>
Otros
</button>
</div>
{filteredContactsByType.length > 0 ? (
<ul className="invitados-listbox-options">
{filteredContactsByType.map((contacto) => (
<li
key={contacto.id}
onClick={() => {
handleSelectClient(contacto, index);
setOpenClientListbox(null);
}}
className="invitados-listbox-option"
>
{contacto.nombre && contacto.apellido
? `${contacto.nombre} ${contacto.apellido}`
: contacto.nombre
? contacto.nombre
: contacto.razonSocial}
</li>
))}
</ul>
) : (
<p className="no-results-message">No se encontraron resultados.</p>
)}
</div>
</div>
))}
</div>
<div 
className="eventos-form-middle-rect-horizontal" 
style={{ 
width: '100%', 
height: '200px',
borderRadius: '10px',
border: '1px solid #ccc'
}}
></div>
{}
<div className="eventos-form-invitados-row" style={{ display: 'flex', gap: '30px',width:'100%', justifyContent:'space-between' }}>
{formData.invitados.slice(4, 8).map((invitado, index) => (
<div key={index + 4} style={{ position: 'relative', margin:'0 auto' }}>
<div
className={`eventos-form-invitado-circle ${invitado ? 'filled' : 'empty'} `}
onClick={() => {
setOpenClientListbox(openClientListbox === index + 4 ? null : index + 4);
setSearchTerm('');
}}
onMouseEnter={() => handleMouseEnter(index + 4)}
onMouseLeave={handleMouseLeave}
>
{invitado ? (
<>
<span>
{invitado.nombre && invitado.apellido
? `${invitado.nombre.charAt(0).toUpperCase()}${invitado.apellido.charAt(0).toUpperCase()}`
: invitado.nombre
? invitado.nombre.charAt(0).toUpperCase()
: invitado.razonSocial
? invitado.razonSocial.charAt(0).toUpperCase()
: ''}
</span>
<div
className="eventos-form-remove-client"
onClick={(e) => {
e.stopPropagation();
handleRemoveClient(index + 4);
}}
>
&times;
</div>
</>
) : (
<span>+</span>
)}
</div>
{hoveredCircleIndex === index + 4 && invitado && (
<div className="custom-tooltip">
{invitado.nombre && invitado.apellido
? `${invitado.nombre} ${invitado.apellido}`
: invitado.nombre
? invitado.nombre
: invitado.razonSocial}
</div>
)}
<div
className={`invitados-listbox-container ${openClientListbox !== index + 4 ? 'hidden' : ''} ${index >= 0 ? 'bottom-listbox' : ''}`} 
ref={openClientListbox === index + 4 ? dropdownRef : null}
style={{left: '50%',}} 
>
<input
type="text"
placeholder="Buscar cliente..."
value={searchTerm}
onChange={(e) => setSearchTerm(e.target.value)}
className="invitados-listbox-search-input"
ref={openClientListbox === index + 4 ? searchInputRef : null}
/>
<div className="filter-buttons-container" style={{ display: 'flex', width: '90%', margin: '5px auto 10px', gap: '5px', flexWrap: 'wrap' }}>
<button
type="button"
className={`filter-button ${contactTypeFilter === 'clientes' ? 'active' : ''}`}
onClick={() => setContactTypeFilter(contactTypeFilter === 'clientes' ? 'todos' : 'clientes')}
ref={(el) => (filterButtonsRef.current[0] = el)}
style={{ maxWidth: 'fit-content', padding: '1px 5px' }}
>
Clientes
</button>
<button
type="button"
className={`filter-button ${contactTypeFilter === 'usuarios' ? 'active' : ''}`}
onClick={() => setContactTypeFilter(contactTypeFilter === 'usuarios' ? '' : 'usuarios')}
ref={(el) => (filterButtonsRef.current[3] = el)}
style={{ maxWidth: 'fit-content', padding: '1px 5px' }}
>Empleados
</button>
<button
type="button"
className={`filter-button ${contactTypeFilter === 'proveedores' ? 'active' : ''}`}
onClick={() => setContactTypeFilter(contactTypeFilter === 'proveedores' ? 'todos' : 'proveedores')}
ref={(el) => (filterButtonsRef.current[1] = el)}
style={{ maxWidth: 'fit-content', padding: '1px 5px' }}
>
Proveedores
</button>
<button
type="button"
className={`filter-button ${contactTypeFilter === 'otros' ? 'active' : ''}`}
onClick={() => setContactTypeFilter(contactTypeFilter === 'otros' ? 'todos' : 'otros')}
ref={(el) => (filterButtonsRef.current[2] = el)}
style={{ maxWidth: 'fit-content', padding: '1px 5px' }}
>
Otros
</button>
</div>
{filteredContactsByType.length > 0 ? (
<ul className="invitados-listbox-options">
{filteredContactsByType.map((contacto) => (
<li
key={contacto.id}
onClick={() => {
handleSelectClient(contacto, index + 4);
setOpenClientListbox(null);
}}
className="invitados-listbox-option"
>
{contacto.nombre && contacto.apellido
? `${contacto.nombre} ${contacto.apellido}`
: contacto.nombre
? contacto.nombre
: contacto.razonSocial}
</li>
))}
</ul>
) : (
<p className="no-results-message">No se encontraron resultados.</p>
)}
</div>
</div>
))}
</div>
</div>
</div>
<div className="button-container" >
<button
type="submit"
className={`eventos-form-submit-btn ${saveState === 'saved' ? 'success' : ''}`}
disabled={isLoading}
>
<span className="button-text">
{saveState === 'saved' ? 'Guardado' : isEditing ? 'Editar degustación' : 'Crear degustación'}
</span>
{isLoading && (
<span className="progress-bar" style={{ width: `${progress}%` }}></span>
)}
</button></div>
</form>
</div>
<CalendarModal
isVisible={isCalendarModalVisible}
onClose={handleCloseCalendarModal}
onDatesSelect={handleDatesSelected}
showTimeInput={true}
// Enviamos la fecha actual en un array para compatibilidad con el modal
initialDates={formData.fechas ? [formData.fechas] : []}
// Nueva prop para indicar que solo se permite una fecha
allowMultipleDates={false}
/>
</div>
);
};
export default DegustacionesForm;